export default __webpack_public_path__ + "static/media/edit.0c1c4eed.svg";